<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26">
        <g fill="#FFF" fill-rule="evenodd">
            <g>
                <path d="M2.932 0l10.246 11.044H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0h.932zm10.223 0c1.105 0 2 .895 2 2v7.044c0 .1-.007.2-.021.296L6.467 0h6.688zM17.698 1.617l1.613-.604c1.034-.388 2.187.136 2.575 1.17.084.225.127.463.127.702V8.16c0 1.104-.895 2-2 2-.24 0-.477-.043-.702-.127l-1.613-.605c-.78-.293-1.298-1.039-1.298-1.873V3.49c0-.834.517-1.58 1.298-1.873z" transform="translate(4.32 7.228)"/>
            </g>
            <path d="M10.991 -2.946L12.315 -2.915 13.039 28.652 11.715 28.621z" transform="rotate(-41 12.015 12.853)"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'video-paused'
}
</script>
